import React from 'react';
import DescriptionCard, { DescriptionCardSkeleton } from 'components/DescriptionCard/DescriptionCard';


const AssetBindingCard = ({ assetInfo, heading, isLoading = false }) => {
  const assetBindingModels = [
    { label: 'Asset Source', path: 'source.displayName' },
    { label: 'Binding Description', path: 'binding.displayName' }
  ];

  return (<>
    { isLoading && <DescriptionCardSkeleton /> }
    { !isLoading && <DescriptionCard
      models={assetBindingModels}
      item={assetInfo}
      heading={heading}
      isLoading={isLoading}
    /> }
  </>
  );

};

export default AssetBindingCard;
